export class CompensationClaim {

    constructor(props?: { [key in keyof CompensationClaim]?: CompensationClaim[key] }) {
        this.guestContactedProofFiles = [];
        this.underlyingInsuranceProofFiles = [];
        this.notes = [];
        this.status = [];
        Object.assign(this, props);
    }

    id: string;

    accommodationId: number;
    accommodationName: string;
    bookingId: number;
    bookingDetails: string;
    numberOfGuests: number;
    bookingPlatformUsed: string;
    bookingPlatformReference: string;
    guestDepositCollected: boolean;
    guestDepositRetained: boolean;
    guestDepositRetainedCurrency: string;
    guestDepositRetainedAmount: number;
    messageToGuest: string;
    applicableDamage: string[];
    guestContactedAboutDamage: boolean;
    guestContactedProofFiles: string[];
    guestContributedToCost: boolean;
    guestContributionCurrency: string;
    guestContributionAmount: number;
    seekingCompensationFromOtherPlatform: boolean;
    seekingCompensationFrom: string;
    seekingCompensationFromReference: string;
    seekingCompensationFromCurrency: string;
    seekingCompensationFromAmount: number;
    preventativeSteps: boolean;
    preventativeStepsDetails: string;

    anyDamagedItems: boolean;
    damagedItems: DamagedItem[];

    underlyingInsurance: boolean;
    underlyingInsuranceProofFiles: string[];

    declarationOfLoss: boolean;

    additionalContactName: string;
    additionalContactEmail: string;
    additionalContactPhone: string;

    status: Status[];

    //This is host user id
    partitionKey: string;
    claimantEmail: string;

    guestUserId: string;
    guestFirstName: string;
    guestLastName: string;

    complete: boolean;
    createdDate: Date;

    notes: Note[];
}


export class DamagedItem {
    constructor(props?: { [key in keyof DamagedItem]?: DamagedItem[key] }) {
        this.costEvidenceFiles = [];
        Object.assign(this, props);
    }

    name: string;
    whatHappened: string[];
    itemAge: number;
    repairOrReplaceCurrency: string;
    repairOrReplaceAmount: number;
    costDetermination: string;
    costEvidenceFiles: string[];
}


export class Note {
    detail: string;
    files: string[];
    author: string;
    createdDate: Date;
}


export class Status {
    name: string;
    note: string[];
    createdDate: Date;
}



export class PriceWithCurrency {
    currency: string;
    price: number;

    constructor(props?: { [key in keyof PriceWithCurrency]?: PriceWithCurrency[key] }) {
        Object.assign(this, props);
    }
}
